import { string, number, instanceOf } from 'prop-types'
import cn from 'classnames'

import Icon from '../../../icon/index.js'
import PostImage from '../../theme-components/post-image.js'
import PostTypeIndicator from '../../theme-components/PostTypeIndicator.js'
import SocialCommerce from '../../theme-components/social-commerce.js'
import Video from '../../theme-components/video.js'
import Post from '../../../../../models/Post.js'
import Settings from '../../../../../models/settings.js'

export default function CarouselPostMedia({ feedKey, post, postWidth, settings }) {
  const { isMinimalistic, socialCommerceButtonPosition, allowCookies, enableWebAnalytics } =
    settings
  const socialCommercePosition = socialCommerceButtonPosition
  return (
    <div className="bzfy-o-image-container">
      <div className="bzfy-o-image-container__clip">
        {post.getIsVideoPost() && settings.autoplayVideos ? (
          <Video
            autoPlay={settings.autoplayVideos}
            mediaIndex={post.thumbnailMediaPosition}
            post={post}
            width={postWidth}
          />
        ) : (
          <PostImage
            className={cn('bzfy-o-image', {
              'bzfy-o-image--commerce':
                !isMinimalistic && post.socialCommerceEnabled && socialCommercePosition === 'top',
            })}
            locale={settings.locale}
            post={post}
            sizes={postWidth}
          />
        )}
      </div>
      {!isMinimalistic && socialCommercePosition === 'top' && (
        <SocialCommerce
          allowCookies={allowCookies}
          className={cn('bzfy-o-commerce', {
            'bzfy-o-commerce--large': settings.socialCommerceButtonLarge,
            'bzfy-o-commerce--image': socialCommercePosition === 'top',
            'bzfy-o-commerce--bottom': socialCommercePosition === 'bottom',
          })}
          enableWebAnalytics={enableWebAnalytics}
          feedKey={feedKey}
          fromGate={false}
          post={post}
          settings={settings}
          target="_blank"
        />
      )}
      <span aria-hidden="true" className="bzfy-o-likes">
        {post.likes}
        <Icon color="#000" icon="likes" />
      </span>

      <PostTypeIndicator
        autoplayEnabled={settings.autoplayVideos}
        post={post}
        settings={settings}
      />
    </div>
  )
}

CarouselPostMedia.propTypes = {
  feedKey: string.isRequired,
  post: instanceOf(Post).isRequired,
  postWidth: number.isRequired,
  settings: instanceOf(Settings).isRequired,
}
